import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HeroSlider } from "@/components/news/HeroSlider";
import { OverlayCard } from "@/components/news/OverlayCard";
import { ArticleCard } from "@/components/news/ArticleCard";
import { SectionTitle } from "@/components/news/SectionTitle";
import { Sidebar } from "@/components/news/Sidebar";
import { CategorySections } from "@/components/news/CategorySections";
import { Skeleton } from "@/components/ui/skeleton";

const OverlayColumn = ({ title, items, label, testId }) => (
  <div data-testid={testId}>
    <SectionTitle>{title}</SectionTitle>
    <div className="grid gap-4">{items.map((a) => <OverlayCard key={a.id} article={a} label={label} />)}</div>
  </div>
);

export default function Home() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/home").then((r) => setData(r.data)).catch((error) => { console.error("Home error:", error); setData({}); });
  }, []);

  if (!data) return <div className="grid lg:grid-cols-4 gap-6"><Skeleton className="lg:col-span-2 h-[460px]" /><Skeleton className="h-[460px]" /><Skeleton className="h-[460px]" /></div>;

  const { featured = [], editors_pick = [], trending = [], popular = [], categories = {}, chronique, magazine, podcasts = [] } = data;

  return (
    <div className="space-y-12" data-testid="home-page">
      <div className="grid lg:grid-cols-4 gap-6">
        <div className="lg:col-span-2"><HeroSlider items={featured} /></div>
        <OverlayColumn title="Choix de la rédaction" items={editors_pick} label="Rédaction" testId="editors-pick-section" />
        <OverlayColumn title="Tendances" items={trending} label="Tendance" testId="trending-section" />
      </div>
      <section>
        <SectionTitle>Les plus lus</SectionTitle>
        <div data-testid="popular-stories-grid" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {popular.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>
      </section>
      <div className="grid lg:grid-cols-4 gap-8">
        <CategorySections categories={categories} />
        <Sidebar chronique={chronique} magazine={magazine} podcasts={podcasts} />
      </div>
    </div>
  );
}
